import type {TextSectionFragmentType} from '@/modules/page/sanity/content-blocks/text-container/query';

import {INLINE_PORTABLE_TEXT_FRAGMENT} from '../inline-portable-text/query';

export const ACCORDION_LIST_FRAGMENT = `//groq
	_type == "accordionList" => {
		...,
		items[] {
			...,
			content[] {
				...,
				${INLINE_PORTABLE_TEXT_FRAGMENT}
			}
		}
	}
`;

export type AccordionListFragment = Extract<
	NonNullable<TextSectionFragmentType['content']>[number],
	{_type: 'accordionList'}
>;
